export enum MemberBankAccountStatus {
  Inactive = 0,
  Active = 1,
  InactiveBySystem = 2,
}

export const MemberBankAccountStatusLabels: Record<MemberBankAccountStatus, string> = {
  [MemberBankAccountStatus.Inactive]: 'Inactive',
  [MemberBankAccountStatus.Active]: 'Active',
  [MemberBankAccountStatus.InactiveBySystem]: 'Inactive(System)',
};

// Operator-editable statuses only; InactiveBySystem is system-driven.
export const MemberBankAccountEditableStatuses = [
  MemberBankAccountStatus.Inactive,
  MemberBankAccountStatus.Active,
];
